<script>
import {jwtDecode} from '@/helpers/jwt.js'
import {mapActions, mapGetters} from 'vuex'
import {InvitationStatus as InvitationStatusEnum} from '@/enums/InvitationStatus'
import InvitationNewUser from '@/components/invitation/InvitationNewUser.vue'
import InvitationExistingUser from '@/components/invitation/InvitationExistingUser.vue'
import InvitationInformation from '@/components/invitation/InvitationInformation.vue'

export default {
  components: {
    NewUser: InvitationNewUser,
    ExistingUser: InvitationExistingUser,
    Information: InvitationInformation,
  },
  data: vm => ({
    loading: true,
    token: vm.$route.params.token,
    firstname: vm.$route.query.firstname,
    lastname: vm.$route.query.lastname,
    tokenDecoded: jwtDecode(vm.$route.params.token),
    tokenStatusEnum: {
      NewUser: 1,
      ExistingUser: 2,
      Expired: InvitationStatusEnum.Expired
    },
    tokenStatus: undefined,
    invitationStatus: undefined,
    invitationStatusContent: {
      [InvitationStatusEnum.Accepted]: {
        color: 'success',
        icon: 'mdi-check',
        message: vm.$t('page.invitation.view.accepted')
      },
      [InvitationStatusEnum.Rejected]: {
        color: 'error',
        icon: 'mdi-information-variant',
        message: vm.$t('page.invitation.view.rejected')
      },
      [InvitationStatusEnum.NotFound]: {
        color: 'error',
        icon: 'mdi-close',
        message: vm.$t('page.invitation.view.notFound')
      },
      [InvitationStatusEnum.Expired]: {
        color: 'error',
        icon: 'mdi-timer-off',
        message: vm.$t( 'page.invitation.view.expired')
      }
    }
  }),
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  async created() {
    // make sure there is no active user / token
    this.logoutUser()
    .then(async () => {
      // get status of invitation
      await this.$organizationService
      .status({token: this.token})
      .then(response => {
        // status is pending, so get all information from token
        if (response.status === InvitationStatusEnum.Pending) {
          // parse ExistingUser to Boolean, it arrives as a upperCased-string
          let existingUser = JSON.parse(
            this.tokenDecoded.ExistingUser.toLowerCase()
          )
          // Token expired
          if (this.tokenDecoded.exp < Math.floor(Date.now() / 1000))
            this.tokenStatus = this.tokenStatusEnum.Expired
          // Existing user
          if (existingUser) this.tokenStatus = this.tokenStatusEnum.ExistingUser
          // New user
          if (!existingUser) this.tokenStatus = this.tokenStatusEnum.NewUser
        } else {
          // status has changed, so the user or admin did a interaction
          this.invitationStatus = response.status
        }
      })
      .catch(e => {
        if (e.response.status === 401)
          this.invitationStatus = InvitationStatusEnum.Expired
        else this.invitationStatus = InvitationStatusEnum.NotFound
      })
      .finally(() => {
        this.loading = false
      })
    })
    .catch(error => {
      console.error('Logout failed: ', error);
    });
  },
  methods: {
    ...mapActions(['logoutUser'])
  },
}
</script>
<template>
  <v-container style="height:81vh">
    <v-row v-if="loading" justify="center" align="center" class="text-center">
      <v-col cols="auto">
        <Information no-button no-icon>
          <v-progress-circular
            indeterminate
            color="primary">
          </v-progress-circular>
          <br/>{{ $t('page.invitation.view.loading') }}
        </Information>
      </v-col>
    </v-row>
    <v-row v-else justify="center" align="center" class="text-center">
      <v-col v-if="invitationStatus" cols="auto">
        <Information
          :color="invitationStatusContent[invitationStatus].color"
          :icon="invitationStatusContent[invitationStatus].icon">
            <span
              v-html="invitationStatusContent[invitationStatus].message">
            </span></Information>
      </v-col>
      <v-col v-else cols="auto">
        <ExistingUser
          v-if="tokenStatus === tokenStatusEnum.ExistingUser"
          :token="token"
          :token-decoded="tokenDecoded"/>
        <NewUser
          v-if="tokenStatus === tokenStatusEnum.NewUser"
          :token="token"
          :firstname="firstname"
          :lastname="lastname"
          :token-decoded="tokenDecoded"/>
        <Information
          v-if="tokenStatus === tokenStatusEnum.Expired"
          :color="invitationStatusContent[tokenStatus].color"
          :icon="invitationStatusContent[tokenStatus].icon">
            <span v-html="invitationStatusContent[tokenStatus].message">
            </span>
        </Information>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss">
.icon_border_round {
  border-radius: 50px;
  border: 2px solid;
  padding: 10px;
  width: 100px;
  height: 100px;
}
</style>
